import gql from 'graphql-tag';

import acceptedSuggestionsFragment from '../fragments/acceptedSuggestionsFragment';

export const mutationAcceptSuggestions = gql`
  mutation acceptSuggestions (
    $suggestedDokkioTags: [SuggestedDokkioTagInput!]
    $suggestedIntegrationItemDokkioTags: [SuggestedIntegrationItemDokkioTagInput!]
    $suggestedDokkioLabelNames: [String!]
    $suggestedWebpageDokkioTags: [SuggestedWebpageDokkioTagInput!]
    $suggestedWebpageSuggestedDokkioTags: [SuggestedWebpageSuggestedDokkioTagInput!]
  ) {
    acceptSuggestions (
      suggestedDokkioTags: $suggestedDokkioTags
      suggestedIntegrationItemDokkioTags: $suggestedIntegrationItemDokkioTags
      suggestedDokkioLabelNames: $suggestedDokkioLabelNames
      suggestedWebpageDokkioTags: $suggestedWebpageDokkioTags
      suggestedWebpageSuggestedDokkioTags: $suggestedWebpageSuggestedDokkioTags
    ) {
      ...acceptedSuggestionsFragment
    }
  }
  ${acceptedSuggestionsFragment}
`;
export default mutationAcceptSuggestions;
